module.exports = __webpack_public_path__ + "static/media/rom23.473b4246.jpg";